export const FLAG_GETTING_BANK_ACCOUNTS = 'FLAG_GETTING_BANK_ACCOUNTS';
export const GET_BANK_ACCOUNTS = 'GET_BANK_ACCOUNTS';
export const CLEAR_BANK_ACCOUNTS = 'CLEAR_BANK_ACCOUNTS';
export const FLAG_BANK_ACCOUNT_ACTIVITY = 'FLAG_BANK_ACCOUNT_ACTIVITY';
export const GET_BANK_ACCOUNT = 'GET_BANK_ACCOUNT';
export const CLEAR_BANK_ACCOUNT = 'CLEAR_BANK_ACCOUNT';
